module.exports = __webpack_public_path__ + "img/ustp.6e10855a.png";